import React from "react";
import "./AppraisalProgress.css";
import AppraisalList from "./AppraisalList";
import Header from "./AppraisalList/component/Header/Header";

const ProbationalAppraisalProgress = () => {
  return (
    <>
      <Header title="Probationary Appraisals" />
      <AppraisalList baseFilters={{ frequency: "probationary" }} />
    </>
  );
};

export default ProbationalAppraisalProgress;
